const ResizableIframe = ({ src, id }) => {
  if (src.includes('.pdf')) return <iframe className={'h-96 w-full'} src={src} id={id} />;
  return (
    <div className={'relative'}>
      <img className={'object-contain'} alt={id} src={src} id={id} />
    </div>
  );
};

export default ResizableIframe;
